<template>
  <div class="setting-box">
    <div class="header">个人信息</div>
    <Form ref="form" :model="form" :rules="ruleForm" @submit.native.prevent>
      <FormItem prop="name">
        <i class="form-icon lastname"></i>
        <Input type="text" v-model.trim="form.name" clearable @on-enter="ok" @on-blur="$root.$emit('RegisterModalRefresh')" :placeholder="$t('account.reg.unamePlaceholder')" />
      </FormItem>
      <FormItem prop="gender">
        <i class="form-icon gender"></i>
        <Select v-model.trim="form.gender" :transfer="true">
          <Option :value="2">男</Option>
          <Option :value="1">女</Option>
        </Select>
      </FormItem>
      <FormItem>
        <div class="upload" @click.prevent="upload">
          <div class="upload-wrap">
            <i class="form-icon portrait"></i>
            <div class="upload-content"><span class="placeholder">{{uploadText}}</span></div>
            <div class="process" :style="`width:${process.width}%`" v-show="isUploading"></div>
            <div class="proces-test" v-show="isUploading">{{$t('common.uploading')}} {{process.value}}%</div>
            <Spin fix v-show="isUploading">
              <Icon type="load-c" size="15" class="spin-icon-load"></Icon>
            </Spin>
            <i class="add-icon" v-show="!isUploading"></i>
          </div>
        </div>
        <viewer :images="[form.portrait]" class="viewer" ref="viewer" v-if="form.portrait" :options="{ zIndex: 19000 }">
          <img v-for="src in [form.portrait]" :src="src" :key="src" :title="$t('common.preview')">
        </viewer>
        <input type="file" ref="fileInput" @change="fileChange($event)" class="upload-input" accept="image/*">
      </FormItem>
    </Form>
    <div class="footer">
      <Button type="primary" :loading="isShowLoader" @click="ok">
        <span v-if="!isShowLoader"><span>{{$t('btn.confirmed')}}</span></span>
        <span v-else>{{$t('btn.confirmed')}}</span>
      </Button>
    </div>
    <Loader :loadType="1" v-show="isShowLoader" class="black"></Loader>
  </div>
</template>

<script>
import Loader from '@/components/layout/Loader'
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'UserProfileZH',
  components: { Loader },
  data () {
    return {
      isSubmit: false,
      isShowLoader: false,
      isUploading: false,
      process: { value: 0, width: 0 },
      form: {
        name: '',
        gender: 2,
        portrait: ''
      },
      ruleForm: {
        name: [
          { required: true, message: this.$t('account.reg.unameMsg'), trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    uploadText () {
      if (this.isUploading) {
        return '头像上传'
      } else {
        if (this.form.portrait) {
          return '重新上传头像'
        } else {
          return '头像上传'
        }
      }
    },
    ...mapState('account', {
      userInfo: state => state.userInfo
    })
  },
  methods: {
    setForm () {
      this.form.name = this.userInfo.name || ''
      this.form.gender = this.userInfo.gender
      this.form.portrait = this.userInfo.portrait
    },
    ok () {
      this.$Loading.start()
      this.isSubmit = true
      this.isShowLoader = true
      this.$api.account.member.updateMember(this.form, {
        success: response => {
          this.$Loading.finish()
          this.isSubmit = false
          this.isShowLoader = false
          if (response.data.code === 200) {
            this.setUserInfo(this._.assign({}, this.userInfo, this.form))
            this.setModalState(false)
          } else {
            this.$Message.error({content: '信息更新失败，请稍后重试', closable: true})
          }
        },
        error: errorMsg => {
          this.$Loading.error()
          this.isSubmit = false
          this.isShowLoader = false
          this.$Message.error({content: '信息更新失败', closable: true})
        }
      })
    },
    uploadFileToAzure (file, sas, container, callback) {
      let fileName = this._h.getRandomStr(15)
      let suffix = this._h.getSuffix(file.name)
      let processValue = this._.random(36, 90)
      this.process.value = processValue
      this.process.width = processValue
      let intervalInst = setInterval(() => {
        processValue = this._.random(processValue, 98)
        this.process.value = processValue
        this.process.width = processValue
        if (processValue > 98) {
          clearInterval(intervalInst)
        }
      }, 300)
      let azureName = 'smartftax'
      let blobUri = `https://${azureName}.blob.core.chinacloudapi.cn`
      let blobService = this.$AzureStorage.createBlobServiceWithSas(blobUri, sas)
      blobService.createBlockBlobFromBrowserFile(container, `${fileName}${suffix}`, file, (error, result) => {
        intervalInst && clearInterval(intervalInst)
        if (!error) {
          this.$Loading.finish()
          this.process.value = 100
          this.process.width = 100
          if (callback && typeof callback === 'function') {
            callback(result)
          }
          this.form.portrait = `${blobUri}/${container}/${fileName}${suffix}`
        } else {
          this.$Loading.error()
          this.$Message.error({content: this.$t('common.uploadError'), closable: true})
        }
        this.isUploading = false
        this.$refs.fileInput.value = null
        setTimeout(() => {
          this.process.value = 0
          this.process.width = 0
        }, 200)
      })
    },
    uploadFiles (files) {
      if (!files || files.length === 0) return
      let isRefused = false
      this._.each(files, (file) => {
        if (file.size > 20 * 1024 * 1024) {
          this.$Message.error({content: this.$t('common.uploadSizeError'), closable: true})
          isRefused = true
          return false
        }
        let suffix = this._h.getSuffix(file.name)
        if (this._.indexOf(['.png', '.jpg', '.jpeg', '.bmp'], suffix) === -1) {
          this.$Message.error({content: this.$t('common.uploadTypeError'), closable: true})
          isRefused = true
          return false
        }
      })
      if (isRefused) {
        this.$refs.fileInput.value = null
        return
      }
      this.$Loading.start()
      this.isUploading = true
      let container = 'content'
      this.$api.getSasToken(container, {
        success: (response) => {
          if (response.data.code === 200) {
            this._.forEach(files, (file) => {
              let sas = response.data.data.sas
              this.uploadFileToAzure(file, sas, container)
            })
          } else {
            this.$Loading.error()
            this.$Message.error({content: this.$t('common.uploadSasError2'), closable: true})
            this.isUploading = false
            this.$refs.fileInput.value = null
          }
        },
        error: (errorMsg) => {
          this.$Loading.error()
          this.$Message.error({content: this.$t('common.uploadSasError'), closable: true})
          this.isUploading = false
          this.$refs.fileInput.value = null
        }
      })
    },
    upload () {
      if (!this.isUploading) {
        this.$refs.fileInput.click()
      }
    },
    fileChange (event) {
      const files = event.target.files
      if (!files || files.length === 0) return
      this.uploadFiles(files)
    },
    ...mapMutations({
      setModalState: 'account/setEditProfileModalState',
      setUserInfo: 'account/setUserInfo'
    })
  }
}
</script>
<style scoped>
  .form-icon.gender{
    background-image: url("~@/assets/images/icons/member/icon_wddh.png");
  }
  .form-icon.portrait{
    background-image: url("~@/assets/images/icons/account/yyzz.png");
  }
  .upload{
    border: 0.5px solid #DBDBDB;
    height: 32px;
    line-height: 32px;
    border-radius: 2px;
    /*padding-left: 25px;*/
    /*padding-right: 24px;*/
    position: relative;
    cursor: pointer;
  }
  .upload-wrap{
    padding-left: 25px;
    padding-right: 24px;
    position: absolute;
    top:0.5px;
    left:0.5px;
    bottom: 0.5px;
    right: 0.5px;
  }
  .upload .upload-content{
    position: relative;
    top: -1px;
  }
  .upload .upload-content .placeholder{
    /*font-size: 10px;*/
    font-size: 12px;
    color: #999;
  }
  .upload .process{
    position: absolute;
    top:0;
    bottom: 0;
    left:0;
    width: 0;
    transition: width 0.3s;
    /*background-color: #2DB7F5;*/
    background-color: rgba(45, 183, 245, 0.2);
    z-index: 10;
  }
  .upload .proces-test{
    position: absolute;
    top:0;
    bottom: 0;
    left:0;
    right: 0;
    z-index: 101;
    /*font-size: 10px;*/
    font-size: 12px;
    color: #333;
    text-align: center;
  }
  .upload .add-icon{
    background-image: url("~@/assets/images/icons/account/add.png");
    background-size: auto 10px;
    width: 10px;
    height: 10px;
    position: absolute;
    right: 7px;
    top: 50%;
    transform: translateY(-50%);
  }
  .upload >>> .ivu-spin-main{
    left: auto;
    right: 1px;
  }
  .upload >>> .ivu-spin .spin-icon-load{
    position: relative;
    top: 1px;
  }
  .spin-icon-load{
    animation: ani-demo-spin 1s linear infinite;
  }
  @keyframes ani-demo-spin {
    from { transform: rotate(0deg);}
    50%  { transform: rotate(180deg);}
    to   { transform: rotate(360deg);}
  }
  .upload-input{
    display: none;
  }
  .viewer{
    position: absolute;
    width: 30px;
    /*top: 0;*/
    /*right: 0;*/
    /*bottom: 0;*/
    /*height: 100%;*/
    top: 0.5px;
    right: 1px;
    bottom: 1px;
    cursor: pointer;
    max-height: 32px;
    overflow: hidden;
  }
  .viewer img{
    width: 100%;
    height: 100%;
  }
  .ivu-form-item >>> .ivu-select .ivu-select-selection{
    padding-left: 17px;
    border-width: 0.5px;
  }
  .ivu-form-item >>> .ivu-select.ivu-select-multiple .ivu-select-selection{
    padding-left: 25px;
    border-width: 0.5px;
  }
  .ivu-form-item >>> .ivu-select.ivu-select-multiple .ivu-select-input,
  .ivu-form-item >>> .ivu-select.ivu-select-multiple .ivu-select-placeholder{
    padding-left: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/account/zh-CN/UserProfile.vue